import { useEffect } from 'react';

function appendKindlyScript(botKey: string) {
  let script = document.getElementById(
    'kindly-chat',
  ) as HTMLScriptElement | null;
  if (script) {
    return script;
  }

  script = document.createElement('script');
  script.id = 'kindly-chat';
  script.src = 'https://chat.kindlycdn.com/kindly-chat.js';
  script.dataset.botKey = botKey;
  script.dataset.language = 'no';
  script.dataset.shadowDom = 'true';
  script.defer = true;

  document.body.appendChild(script);
  return script;
}

export function useKindlyChat(botKey: string) {
  useEffect(() => {
    if (!botKey) {
      return;
    }

    appendKindlyScript(botKey);

    document.addEventListener('kindly:load', _ => {
      const triggerButton = document.getElementById('kindly-bot-trigger-chat');
      triggerButton?.addEventListener('click', () => {
        // @ts-expect-error
        window.kindlyChat.openChat();
      });
    });
  }, [botKey]);
}
